<template>
  <div class="view requests-view">
    <Requests />
  </div>
</template>

<script>
import Requests from '../components/Requests.vue';

export default {
  name: 'OrgRequestsView',
  components: {
    Requests,
  },
};
</script>

<style>
.contracts-view {
  display: flex!important;
}
</style>
